import ImageAndCtaCards from '@rsa-digital/evo-shared-components/components/ImageAndCtaCards';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledImageAndCtaCards = styled(ImageAndCtaCards)`
  margin-top: 0;
  margin-bottom: 0;
  padding-top: ${spacing(3)};
  padding-bottom: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
  `}
`;
